<template>
  <div class="p-2 video_setting" :class="{ 'isPopup': $root.isPopup }">
    <div class="flex justify-between">
      <h3>{{ $e("Options") }} :</h3>

      <div class="flex items-center cursor-pointer btn" @click="config.settingOpen = false">
        {{$e("Fermer")}}
      </div>
    </div>
    <div class="flex flex-col">
      <GimbalReset :config="config" />

      <IrPalette :config="config" />
    </div>
  </div>
</template>
<script>
import GimbalReset from "@/partials/Video/Camera/Options/Gimbal/GimbalReset.vue";
import IrPalette from "@/partials/Video/Camera/Options/IrPalette.vue";
export default {
  name: "Setting",
  components: {
    GimbalReset,
    IrPalette,
  },
  props: {
    config: {
      type: Object,
    },
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
